import { ReduxData } from '../../global/types'

export const SET_DATA = 'DATA/SET_DATA'

export type SetDataAction = {
  type: typeof SET_DATA
  data: ReduxData
}

export const setData = (data: ReduxData): SetDataAction => ({
  type: SET_DATA,
  data,
})
